import React from 'react';

import { Heading } from '../../Heading/Heading';
import { LockIcon } from '../../Icons/LockIcon';
import { Text } from '../../Text/Text';
import style from '../CatchMap.module.css';

interface ICatchMapFooterProps {
  waterName: string;
  message: string;
  isPrivate: boolean;
}

export const CatchMapFooter = ({ message, waterName, isPrivate }: ICatchMapFooterProps) => (
  <div className="z-mid col-start-1 row-start-1 flex size-full flex-col">
    <div className="flex grow items-end">
      <div className={`w-full ${style.mapFooter}`}>
        <div className="mb-3 ml-3">
          <Heading className="mb-1" color="light" variant="2xs">
            {waterName}
          </Heading>
          <div className="flex">
            {isPrivate && (
              <div className="text-sea-foam -mt-1 mr-1">
                <LockIcon height="17" width="17" />
              </div>
            )}
            <Text variant="xs" className="text-sea-foam mb-0">
              {message}
            </Text>
          </div>
        </div>
      </div>
    </div>
  </div>
);
